import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 16v-8","key":"svg-0"}],["path",{"d":"M10 12h4","key":"svg-1"}],["path",{"d":"M14 8v8","key":"svg-2"}],["path",{"d":"M17 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2l-2 0","key":"svg-3"}],["path",{"d":"M3 8v6a2 2 0 1 0 4 0v-6","key":"svg-4"}]]

const IconUhd = createReactComponent('outline', 'uhd', 'Uhd', __iconNode);

export default IconUhd;